import AdminCampaignList from "@/Component/Admin/AdminCampaign";
import type { Metadata } from "next";

export const metadata: Metadata = {
  title: "Campaigns | Connector Club",
  description: "",
};

const AdminCampaignsPage = () => {
  return (
    <AdminCampaignList />
  )
}

export default AdminCampaignsPage
